export default __webpack_public_path__ + "static/media/profile-icon.799011c2.svg";